var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/core-js/library/modules/$.cof.js
 ** module id = 36
 ** module chunks = 2
 **/